<div [formGroup]="form">
  <ng-container>
    <textarea
      class="form-control"
      [formControlName]="field.alias"
      type="textarea"
      [id]="'ba-'+ field.alias"
      [ngClass]="{'is-invalid':!control.valid && (control.touched || control.dirty)}"
    ></textarea>
  </ng-container>
</div>
